import { __extends } from "tslib";
import { Event } from './Event';
import { axCoerceString } from '@awayjs/graphics';
var StageVideoEvent = /** @class */ (function (_super) {
    __extends(StageVideoEvent, _super);
    function StageVideoEvent(type, bubbles, cancelable, status, colorSpace) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (status === void 0) { status = null; }
        if (colorSpace === void 0) { colorSpace = null; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        _this.status = axCoerceString(status);
        _this.colorSpace = axCoerceString(colorSpace);
        return _this;
    }
    StageVideoEvent.classInitializer = null;
    StageVideoEvent.classSymbols = null;
    StageVideoEvent.instanceSymbols = null;
    // JS -> AS Bindings
    StageVideoEvent.RENDER_STATE = 'renderState';
    StageVideoEvent.RENDER_STATUS_UNAVAILABLE = 'unavailable';
    StageVideoEvent.RENDER_STATUS_SOFTWARE = 'software';
    StageVideoEvent.RENDER_STATUS_ACCELERATED = 'accelerated';
    return StageVideoEvent;
}(Event));
export { StageVideoEvent };
